<template>
  <div class="deliverable-assets-view">
    <div class="breadcrumb-header pa-4 d-flex align-center">
      <v-btn icon @click="closeScreen" class="mr-2">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="text-h6">{{ jobData.job_title || 'Job' }}</span>
      <v-icon class="mx-2">mdi-chevron-right</v-icon>
      <span class="text-h6 grey--text">{{ $t('deliverable_assets') }}</span>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="$refs.approvalLinkModal.open()">
        <v-icon left>mdi-share-variant</v-icon>
        {{ $t('generate_approval_link') }}
      </v-btn>
    </div>

    <DeliverableAssetsManagement
      :job-id="jobId"
      :job-data="jobData"
      :customer-id="customerId"
    />

    <ApprovalLinkModal
      ref="approvalLinkModal"
      :job-id="effectiveJobId"
      :job-title="jobData.job_title"
      :job-app-id="$route.params.appId"
      :content-app-id="$route.params.contentAppId"
      :business-app-id="$route.params.businessAppId"
    />
  </div>
</template>

<script>
import DeliverableAssetsManagement from '@/components/job/DeliverableAssetsManagement.vue'
import ApprovalLinkModal from '@/components/job/ApprovalLinkModal.vue'
import JobAPI from '@/services/api/job/job'

export default {
  name: 'JobDeliverableAssets',

  components: {
    DeliverableAssetsManagement,
    ApprovalLinkModal
  },

  props: {
    jobId: {
      type: [String, Number],
      default: null
    },
    customerId: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      jobData: {}
    }
  },

  computed: {
    effectiveJobId() {
      return this.jobId || this.$route.params.jobId
    },

  },

  mounted() {
    this.loadJobData()
  },

  methods: {
    async loadJobData() {
      const effectiveJobId = this.effectiveJobId

      if (!effectiveJobId) return

      try {
        const response = await JobAPI.getJob(effectiveJobId)
        this.jobData = response.data || {}
      } catch (error) {
        console.error('Error loading job data:', error)
      }
    },

    closeScreen() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.deliverable-assets-view {
  min-height: 100vh;
  background-color: #f5f5f5;
}
</style>
